import { updateObject } from 'utils/updateObject'
import setFilters from 'store/reducer-utils/setFilters'

import {
  DROP_LIST,
  REMOVE_FROM_LIST,
  SET_DATA,
  SET_FILTERS,
  SET_LOADING,
  SET_ITEM_DATA,
} from 'modules/Advertisers/List/types'

const initialState = {
  loading: true,
  loaded: false,
  data: [],
  pagination: {
    offset: 0,
    limit: 50,
    total: 0,
  },
  filters: null,
}

const setAdvertisers = (state, { payload }) =>
  updateObject(state, {
    ...payload,
    data: [...state.data, ...payload.data],
    loading: false,
    loaded: true,
  })

const updateAdvertiser = (state, { payload }) =>
  updateObject(state, {
    data: state.data.map((item) =>
      item.id === payload.id ? { ...item, ...payload } : item,
    ),
  })

const advertisersSetFilter = (state, action) => {
  const filteredPayload = state?.filters
    ? [...action.payload].filter(
        (filter) => Object.keys(state.filters).indexOf(filter.fieldName) > -1,
      )
    : action.payload

  return setFilters(state, { ...action, payload: filteredPayload })
}

const setLoading = (state, { payload }) => updateObject(state, payload)

const dropAdvertisersList = (state) =>
  updateObject(state, {
    data: [],
    pagination: {
      offset: 0,
      limit: 50,
      total: 0,
    },
  })

const advertiserRemoveFromList = (state, { payload }) =>
  updateObject(state, {
    data: state.data.filter((item) => item.id !== payload.id),
    pagination: { ...state.pagination, total: state.pagination.total - 1 },
  })

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_LOADING:
      return setLoading(state, action)
    case SET_DATA:
      return setAdvertisers(state, action)
    case SET_ITEM_DATA:
      return updateAdvertiser(state, action)
    case SET_FILTERS:
      return advertisersSetFilter(state, action)
    case REMOVE_FROM_LIST:
      return advertiserRemoveFromList(state, action)
    case DROP_LIST:
      return dropAdvertisersList(state, action)
    default:
      return state
  }
}

export default reducer
